// extracted by mini-css-extract-plugin
export default {"contact":"_1XW0_Ws6n-zImAv2GcV0fH","contactBtn":"_1kxzEWE_fkw4Hudbzqp_Wg"};